import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeakAngVelocity = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_117",
	"data-name": "Group 117",
	xmlns: "http://www.w3.org/2000/svg",
	width: 72.551,
	height: 33.802,
	viewBox: "0 0 72.551 33.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_31",
			"data-name": "Rectangle 31",
			width: 72.551,
			height: 33.802,
			transform: "translate(0)",
			fill: "none"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_116",
			"data-name": "Group 116",
			transform: "translate(10.517 1.888)",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Group_114",
				"data-name": "Group 114",
				transform: "translate(0 0)",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_260",
					"data-name": "Path 260",
					d: "M250.9,389.116c-.244-.307-.528-.653-.832-1.023a22.967,22.967,0,0,1-3.112-4.368c-.519-1.538-1.421-5.958-1.785-7.787a1.256,1.256,0,0,0-.355-.648c.157-.192.329-.39.534-.595,1.318-1.328,4.613-4.574,4.613-4.574l-1.482-1.5s-3.306,3.257-4.63,4.59a9.453,9.453,0,0,0-1.844,2.545l-.083.058a3.355,3.355,0,0,1-1.616-1.242,4.239,4.239,0,0,1-.489-1.7c0-.046-.021-.09-.028-.135.315-.221.7-.512,1.214-.893a30.517,30.517,0,0,0,4.454-5.04,1.056,1.056,0,1,0-1.714-1.232,28.05,28.05,0,0,1-4.005,4.582c-.663.5-1.052.774-1.277.929a2.132,2.132,0,0,0-1.354-.07,10.4,10.4,0,0,0-1.842.735,19.15,19.15,0,0,0-3.1,1.929,6.314,6.314,0,0,0-2.226.8,1.056,1.056,0,0,0-.593.791,6.568,6.568,0,0,0,1.831,4.979c1.9,2.269,8.763,8.937,9.088,9.251.154.136,3.8,3.353,7.033,3.673q.328.032.639.032a3.468,3.468,0,0,0,3.215-1.549A2.278,2.278,0,0,0,250.9,389.116Zm-1.6,1.531c-.125.23-.7.534-1.791.426-2.112-.209-4.931-2.345-5.8-3.118-.07-.069-7.072-6.875-8.908-9.062a5.454,5.454,0,0,1-1.343-2.779c.332-.145.629-.263.785-.314l.157.015a1.058,1.058,0,0,0,.8-.258,15.568,15.568,0,0,1,3.017-1.924,7.412,7.412,0,0,1,1.491-.582c.013.009.014.015.014.019h0a6.263,6.263,0,0,0,.762,2.554,5.772,5.772,0,0,0,3.384,2.389,1.057,1.057,0,0,0,.912-.2c.17-.135.359-.272.541-.394.48,2.359,1.177,5.608,1.639,6.979.418,1.235,1.763,2.936,3.481,5.031.3.362.575.7.812,1C249.346,390.554,249.314,390.612,249.3,390.646Z",
					transform: "translate(-224.972 -365.13)",
					fill: "#101820"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_261",
					"data-name": "Path 261",
					d: "M236.064,402.77l-1.969-3.454a1.056,1.056,0,0,0-1.834,1.046l.81,1.42a12.871,12.871,0,0,1-6.909-3.808c-4.062-4.062-2.794-7.59-2.729-7.76a1.056,1.056,0,0,0-1.96-.784c-.081.2-1.91,4.929,3.2,10.036a15.127,15.127,0,0,0,7.53,4.291l-1.028.587a1.056,1.056,0,0,0,1.046,1.834l3.453-1.97a1.056,1.056,0,0,0,.48-1.245A1.029,1.029,0,0,0,236.064,402.77Z",
					transform: "translate(-221.088 -376.293)",
					fill: "#101820"
				})]
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group_115",
				"data-name": "Group 115",
				transform: "translate(31.058 4.97)",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_262",
					"data-name": "Path 262",
					d: "M295.148,378.529v-1.757a2.228,2.228,0,0,0-2.225-2.225H290.04a2.228,2.228,0,0,0-2.225,2.225v1.751a8.906,8.906,0,0,0-1.363.762,1.056,1.056,0,1,0,1.194,1.742,6.8,6.8,0,1,1-2.866,6.681l1.08,1.08a1.056,1.056,0,0,0,1.493-1.493l-2.811-2.812a1.055,1.055,0,0,0-1.493,0l-2.812,2.812a1.056,1.056,0,0,0,1.493,1.493l.938-.938a8.9,8.9,0,1,0,12.479-9.321Zm-5.222-.658v-1.1a.114.114,0,0,1,.114-.114h2.883a.114.114,0,0,1,.113.114v1.1a8.878,8.878,0,0,0-1.555-.145A8.974,8.974,0,0,0,289.926,377.871Z",
					transform: "translate(-279.928 -374.547)",
					fill: "#101820"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_263",
					"data-name": "Path 263",
					d: "M300.873,386.529a1.056,1.056,0,0,0-1.056,1.056v4.709a1.056,1.056,0,0,0,.309.746l2.534,2.534a1.056,1.056,0,0,0,1.493-1.493l-2.225-2.225v-4.271A1.056,1.056,0,0,0,300.873,386.529Z",
					transform: "translate(-289.319 -380.204)",
					fill: "#101820"
				})]
			})]
		})
	]
});
const ForwardRef = forwardRef(SvgPeakAngVelocity);
export { ForwardRef as ReactComponent };
